import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';

import { colors } from 'settings/theme';
import Typography from 'components/vistaprintUILibrary/Typography';
import withScreenClass, { withScreenClassPropTypes } from 'components/highOrder/withScreenClass';

function SectionHeading(props) {
  const {
    text,
    alignment,
    containerStyle,
    screenClass,
  } = props;

  const isExtraSmallScreen = screenClass === 'xs';

  let alignItems = 'flex-start';
  switch (alignment) {
    case 'left':
      alignItems = 'flex-start';
      break;
    case 'center':
      alignItems = 'center';
      break;
    case 'right':
      alignItems = 'flex-end';
      break;
    default:
      throw new Error(`Unexpected value for alignment ${alignment}. See SectionHeading.propTypes for acceptable values`);
  }

  return (
    <div
      style={{
        width: '100%',

        display: 'flex',
        flexDirection: 'column',
        alignItems,

        marginBottom: 20,
        ...containerStyle,
      }}
    >
      <div
        style={{
          textAlign: isExtraSmallScreen ? 'center' : 'left',
        }}
      >
        <Typography
          variant="heading1"
          text={text}
          style={{
            marginBottom: 10,
          }}
        />
        <div
          style={{
            width: 60,
            height: 3,
            backgroundColor: colors.blueDark,
            display: isExtraSmallScreen ? 'inline-block' : '',
          }}
        />
      </div>
    </div>
  );
}

SectionHeading.propTypes = {
  text: PropTypes.string.isRequired,
  alignment: PropTypes.oneOf(['left', 'center', 'right']).isRequired,
  containerStyle: StylePropType,
};

SectionHeading.propTypes = {
  ...withScreenClassPropTypes,
};

SectionHeading.defaultProps = {
  containerStyle: {},
};

export default withScreenClass(SectionHeading);



// WEBPACK FOOTER //
// ./src/components/SectionHeading.js